import React, { useState, useEffect, Fragment } from 'react'
import {
  Menu,
  MenuItem,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  Icon,
  Divider,
  Fab,
  Slide,
  Fade,
  SvgIcon,
} from '@material-ui/core'
import { VerifiedUser, PersonAdd, Apps } from '@material-ui/icons'
import { Link } from 'react-router-dom'
import { MdSettings, MdAccountCircle, MdVerifiedUser } from 'react-icons/md'
import { TiThList } from 'react-icons/ti'
import { BiLeftArrowAlt } from 'react-icons/bi'
import { BsCardList } from 'react-icons/bs'

function SalesConsultantIcon(props) {
  return(
    <SvgIcon {...props}>
      <path fill="currentColor" d="M2 3H22A2.07 2.07 0 0 1 24 5V19A2.07 2.07 0 0 1 22 21H2A2.07 2.07 0 0 1 0 19V5A2.07 2.07 0 0 1 2 3M8 13.91C6 13.91 2 15 2 17V18H14V17C14 15 10 13.91 8 13.91M8 6A3 3 0 1 0 11 9A3 3 0 0 0 8 6M17 10V13H21V10H17" />
    </SvgIcon>
  )
}

function LicenseeIcon(props) {
  return(
    <SvgIcon {...props}>
      <path fill="currentColor" d="M12,5.5A3.5,3.5 0 0,1 15.5,9A3.5,3.5 0 0,1 12,12.5A3.5,3.5 0 0,1 8.5,9A3.5,3.5 0 0,1 12,5.5M5,8C5.56,8 6.08,8.15 6.53,8.42C6.38,9.85 6.8,11.27 7.66,12.38C7.16,13.34 6.16,14 5,14A3,3 0 0,1 2,11A3,3 0 0,1 5,8M19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14C17.84,14 16.84,13.34 16.34,12.38C17.2,11.27 17.62,9.85 17.47,8.42C17.92,8.15 18.44,8 19,8M5.5,18.25C5.5,16.18 8.41,14.5 12,14.5C15.59,14.5 18.5,16.18 18.5,18.25V20H5.5V18.25M0,20V18.5C0,17.11 1.89,15.94 4.45,15.6C3.86,16.28 3.5,17.22 3.5,18.25V20H0M24,20H20.5V18.25C20.5,17.22 20.14,16.28 19.55,15.6C22.11,15.94 24,17.11 24,18.5V20Z" />
    </SvgIcon>
  )
}

export default function AdminMenu(props) {
  const { open, handleAdminOpen } = props
  const menuItems = [
    {option: "dashboard catalog", icon: <BsCardList style={{fontSize: "24px"}}/>, path: "", timeout: 250},
    {option: "sales consultants", icon: <SalesConsultantIcon />, path: "", timeout: 500},
    {option: "licensee participation", icon: <LicenseeIcon />, path: "", timeout: 750},
  ]

  return (
    <div id="admin-menu">
      <Fade in={open} timeout={250} mountOnEnter unmountOnExit>
        <Typography variant="caption" className="back-btn">
          GO BACK
          <Fab size="small" className="fab" onClick={handleAdminOpen}>
            <BiLeftArrowAlt style={{fontSize: "15px"}}/>
          </Fab>
        </Typography>
      </Fade>

      {menuItems.map(({option, icon, path, timeout}, i) => (
        <Fragment key={`option-${i}`}>
          <Slide in={open} timeout={timeout} direction="down" mountOnEnter unmountOnExit>
            <ListItem>
              <Link
                to={{
                  pathname: path
                }}
              >
                <div className="list-item">
                  {icon}
                  <Typography variant="caption" className="list-item-text">
                    {option.toUpperCase()}
                  </Typography>
                </div>
              </Link>
            </ListItem>
          </Slide>

          <Fade in={open} mountOnEnter unmountOnExit>
            <Divider style={{backgroundColor: "#fff", opacity: 0.5}}/>
          </Fade>
        </Fragment>
      ))}
    </div>
  )
}
